import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { Entities_Team_MovePlayers_Team } from '@suntex.fim/api-client';
import { useFramework } from '@suntex.fim/framework';

import { useTeamContext } from '../context';

export interface UseTeamMovePlayersResult {
  teams: Entities_Team_MovePlayers_Team[];
  isLoading: boolean;
  reload: () => void;
}

/**
 * Loads the move-players board (teams + players) for the team in the
 * surrounding `TeamProvider`. Skipped when no team id is available.
 */
export function useTeamMovePlayers(): UseTeamMovePlayersResult {
  const { teamId } = useTeamContext();
  const { api } = useFramework();
  const queryClient = useQueryClient();

  const { data = [], isLoading } = useQuery({
    queryKey: ['team', 'movePlayers', teamId],
    queryFn: async () => {
      const response = await api.get_Team_MovePlayers({ teamId: teamId! });
      return response.team;
    },
    enabled: teamId !== null,
  });

  const reload = useCallback(() => {
    void queryClient.invalidateQueries({
      queryKey: ['team', 'movePlayers', teamId],
    });
  }, [queryClient, teamId]);

  return { teams: data, isLoading, reload };
}
